var _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLinter = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.754 10.346a.72.72 0 0 1 .167.935l-1.205 2.44-2.442 1.207a.72.72 0 0 1-.937-.168l-1.9-2.92a2.418 2.418 0 0 1 3.4-3.398zM7.056 7.062.976.968"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8.025 9.58-.97-.956a1.105 1.105 0 0 1 1.563-1.562l.976.962M12.774 14.187l-1.968-1.969M14.358 12.421l-2.146-1.61M10.35 4.718h2.813M11.757 3.312v2.812M6.132 1.906h1.875M7.07.968v1.875M.976 8H2.85M1.913 7.062v1.875M5.194 14.093H7.07M6.132 13.156v1.874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.649 1.906a.234.234 0 1 1 0-.47M13.649 1.906a.234.234 0 0 0 0-.47M2.337 13.584a.235.235 0 0 1 0-.469M2.337 13.584a.235.235 0 0 0 0-.469M5.089 11.138a.234.234 0 1 1 0-.469M5.089 11.138a.234.234 0 1 0 0-.469"
  }))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: fill,
    stroke: stroke
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.754 10.346a.72.72 0 0 1 .167.935l-1.205 2.44-2.442 1.207a.72.72 0 0 1-.937-.168l-1.9-2.92a2.418 2.418 0 0 1 3.4-3.398zM7.056 7.062.976.968"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8.025 9.58-.97-.956a1.105 1.105 0 0 1 1.563-1.562l.976.962M12.774 14.187l-1.968-1.969M14.358 12.421l-2.146-1.61M10.35 4.718h2.813M11.757 3.312v2.812M6.132 1.906h1.875M7.07.968v1.875M.976 8H2.85M1.913 7.062v1.875M5.194 14.093H7.07M6.132 13.156v1.874"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.649 1.906a.234.234 0 1 1 0-.47M13.649 1.906a.234.234 0 0 0 0-.47M2.337 13.584a.235.235 0 0 1 0-.469M2.337 13.584a.235.235 0 0 0 0-.469M5.089 11.138a.234.234 0 1 1 0-.469M5.089 11.138a.234.234 0 1 0 0-.469"
  }))));
});
export default SvgIconLinter;
export const raw = __webpack_public_path__ + "static/media/IconLinter.86d9021b039eeabe6d0cee7a4126df2b.svg";